<template>
    <b-modal
        v-bind="$attrs"
        v-on="$listeners"
        :visible="open"
        @hidden="toClose"
        centered
        hide-header
        hide-footer
        size="lg"
    >
        <div class="article">
            <div class="section">
                <h1 class="title">Termos de Gerenciamento de Cookies</h1>
                <p>
                    Cookies são arquivos temporários que armazenam informações básicas do usuário ao navegar pelos
                    sites, aplicativos e sistema CoBlue.
                </p>
                <p>
                    O objetivo do uso de cookies nos sistemas CoBlue, é de fornecer um serviço mais personalizado e
                    eficaz baseado nas escolhas dos usuários (análise de tendências).
                </p>
                <p>
                    Sendo assim, a CoBlue poderá coletar informações básicas de navegação (para melhorar a experiência
                    do usuário) sempre que a função de cookies estiver ativa.
                </p>
                <p>
                    Como a maioria das empresas de tecnologia, coletamos automaticamente esses dados e os armazenamos em
                    arquivos de registro sempre que você visita nosso site ou acesse sua conta em nosso sistema. Quais
                    os tipos de Cookies que a Coblue pode utilizar?
                </p>
            </div>
            <div class="section">
                <div class="section-header">
                    <h2 class="subtitle">Cookies Persistentes</h2>
                    <span class="status">Sempre ativo</span>
                </div>
                <p>
                    Estes cookies são necessários para o correto funcionamento do nosso site. Geralmente, são
                    configurados para atender solicitações de serviços como: preenchimento de formulários, preferências
                    de privacidade e início de sessão. Você pode configurar seu navegador para bloquear e alertar sobre
                    o uso desse tipo de cookie, contudo o site pode ter problemas no seu funcionamento.
                </p>
            </div>
            <div class="section">
                <div class="section-header">
                    <h2 class="subtitle">Cookies de Sessão</h2>
                    <span class="status">Sempre ativo</span>
                </div>
                <p>
                    Estes cookies estão associados com a memória de curto prazo. O objetivo no uso desse cookie é de
                    reconhecer o usuário a cada sessão iniciada. Os cookies de sessão são expirados assim que o
                    navegador é fechado.
                </p>
            </div>
            <div class="section">
                <div class="section-header">
                    <h2 class="subtitle">Cookies de terceiros</h2>
                    <b-checkbox switch v-model="thirdPartyCookies" />
                </div>
                <p>
                    O uso deste tipo de cookie é voltado para publicidade de nossos parceiros. Podem ser usados por
                    outras empresas para criar um perfil de interesse de usuários e mostrar anúncios assertivos em
                    outros sites. Eles não armazenam informações pessoais. A desativação não compromete o desempenho do
                    site.
                </p>
                <p>
                    Você pode optar por limitar, recusar ou desabilitar os Cookies através das configurações de
                    Gerenciamento de cookies. Contudo, ao fazer isso, algumas áreas do nosso site podem não funcionar
                    corretamente, o que poderá impedir que você se beneficie de alguns de nossos recursos. Esta Política
                    de Cookies não cobre o uso de Cookies por terceiros, e não somos responsáveis por suas políticas e
                    práticas de privacidade. Tenha em atenção que os Cookies colocados por terceiros podem eventualmente
                    continuar a monitorizar as suas atividades online mesmo depois de ter saído dos nossos Serviços. A
                    CoBlue se reserva o direito de atualizar a presente Política de Cookies a qualquer momento,
                    mantendo-a sempre disponível no site. Em caso de atualização, o usuário será informado sobre a
                    alteração e poderá optar pela desativação de cookies da CoBlue.
                </p>
            </div>
            <div class="d-flex justify-content-end">
                <b-button @click="onSave" variant="primary">{{ $t('save') }}</b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'ModalOptionalCookies',
    props: {
        open: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            thirdPartyCookies: true,
        }
    },
    methods: {
        onSave() {
            this.$emit('thirdPartyCookies', this.thirdPartyCookies)
            this.toClose()
        },
        toClose() {
            this.$emit('onClose')
            this.$emit('update:open', false)
        },
    },
    i18n: {
        messages: {
            'en-US': {
                save: 'Save',
            },
            'es-ES': {
                save: 'Salvar',
            },
            'pt-BR': {
                save: 'Salvar',
            },
        },
    },
}
</script>

<style lang="scss" scoped>
.article {
    font-family: Roboto, sans-serif;
    text-align: justify;
    padding: 16px;
}
.title {
    font-size: 20px;
    font-weight: 700;
    color: #5d9cec;
}
.section {
    margin-bottom: 24px;
}
.section-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
}
.subtitle,
.status {
    color: #656565;
    font-size: 14px;
}
.subtitle {
    font-weight: 500;
    margin: 0;
}
.status {
    font-weight: 800;
}
</style>
